import { memo } from "react";
import Spinner from "../Spinner";
import FallbackContainer from "./Container";

export const Loader = memo(function Loader() {
  return (
    <FallbackContainer>
      <Spinner data-testid="loader" size="large" />
    </FallbackContainer>
  );
});

export default Loader;
